import { render, staticRenderFns } from "./prescription-dialog.vue?vue&type=template&id=707c4bb1&scoped=true"
import script from "./prescription-dialog.vue?vue&type=script&lang=ts"
export * from "./prescription-dialog.vue?vue&type=script&lang=ts"
import style0 from "./prescription-dialog.vue?vue&type=style&index=0&id=707c4bb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c4bb1",
  null
  
)

export default component.exports